// custom scripts
// mcs / 2018




// WINDOW SCROLLED
$(window).scroll(function() {  
  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }


  
});







$(document).ready(function() {


  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);




  $('.mcs-nav-basics').hover(function() {
    $('.wolven-dropdown-2021.wolven-dropdown-colors').addClass('active');
  }, function() {
    $('.wolven-dropdown-2021.wolven-dropdown-colors').removeClass('active');
  });

  $('.mcs-nav-prints').hover(function() {
    $('.wolven-dropdown-2021.wolven-dropdown-prints').addClass('active');
  }, function() {
    $('.wolven-dropdown-2021.wolven-dropdown-prints').removeClass('active');
  });

  // main drop
  $('.wolven-dropdown-2021').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });

  






  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });





  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
              top = self.offset().top,
              bottom = top + self.height(),
              topOnScreen = top >= viewportTop && top <= viewportBottom,
              bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
              elemVisible = topOnScreen || bottomOnScreen;
              self.toggleClass('visible', elemVisible);    


        });
    };
  viewport.scroll(setVisible);
  setVisible();
  

  // important scripts
  function loadScript(url, callback) {
      // Adding the script tag to the head as suggested before
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      // Then bind the event to the callback function.
      // There are several events for cross browser compatibility.
      script.onreadystatechange = callback;
      script.onload = callback;
      // Fire the loading
      head.appendChild(script);
  }
  loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/wolven.js");




   $('.dropdowns-slider').flickity({
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,
    cellAlign: 'left',
    pageDots: false,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

    

}); // clode doc ready






$(window).on('load', function() {


  $('body').addClass('page-loaded');
  $('.site-overlay').addClass('loaded');

  $('.mcs-article-slider').flickity({
    wrapAround: true,
    pageDots: false,
    imagesLoaded: true,
    prevNextButtons: true,
    cellAlign: 'left',
    pageDots: false,
    autoPlay: 3000,
    pauseAutoPlayOnHover: false,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });



  



});



